class ZoneComponentData {
	constructor() {
		this.enabled = true;
	}
}

export { ZoneComponentData };
